import React, { FunctionComponent } from 'react';

import DatePicker from '../DatePicker';

type Props = DrainDownStepProps &
  Pick<DrainDownForm, 'drainDownSlotId' | 'keyBoxCode'> & {
    availableSlots?: DrainDownSlot[];
  };

const DrainDownDate: FunctionComponent<Props> = ({
  onStepChange,
  onFormChange,
  drainDownSlotId,
  keyBoxCode,
  availableSlots,
}) => {
  return (
    <DatePicker
      title="Select Dates for Drain Down"
      onProceed={onStepChange}
      onFormChange={onFormChange}
      name="drainDown"
      value={drainDownSlotId}
      buttonText="Next"
      keyBoxCode={keyBoxCode}
      availableSlots={availableSlots}
    />
  );
};

export default DrainDownDate;
